import packages from "../collections/packages";

export const Types = {
    setActiveLang: 'REDUX_ACTION_setActiveLang',
    setSame: 'REDUX_ACTION_setSame',
    setStartDate: 'REDUX_ACTION_setStartDate',
    setEndDate: 'REDUX_ACTION_setEndDate',
    setTemplate: 'REDUX_ACTION_setTemplate',
    setCalc: 'REDUX_ACTION_setCalc',
    setGrade: 'REDUX_ACTION_setGrade',

};
export const setActiveLang = (data) => ({
    type: Types.setActiveLang,
    lang: data.lang,
});

export const setSame = (data) => ({
    type: Types.setSame,
    isSame: data.isSame,
});
export const setStartDate = (data) => ({
    type: Types.setStartDate,
    startDate: data.startDate,
});
export const setEndDate = (data) => ({
    type: Types.setEndDate,
    endDate: data.endDate,
});
export const setTemplate = (data) => ({
    type: Types.setTemplate,
    template: data.template,
    product : data.product
});
export const setCalc = (data) => ({
    type: Types.setCalc,
    calc: data.calc,
    no1: data.no1
});
export const setGrade = (data) => ({
    type: Types.setGrade,
    grade: data.grade,
});